import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CheckmarkIcon} from '../icon/svg/checkmark-icon';
import {WarningIcon} from '../icon/svg/warning-icon';

export const Level = {
    VERIFIED: 'verified',
    PENDING: 'pending',
} as const;

export type Level = (typeof Level)[keyof typeof Level];

export type IconStatusProps = {
    level: Level;
    text: string;
};

type Props = IconStatusProps;

export function IconStatus(props: Props) {
    const Icon = getIcon(props.level);
    const iconColor = getIconColor(props.level);
    const textColor = getTextColor(props.level);

    return (
        <div className='font-size-small flex align-center'>
            <Icon className='mr-8' color={iconColor} size={13} alignCenter={true} />
            <span style={{color: textColor}}>{props.text}</span>
        </div>
    );
}

export function getIconColor(level: Level) {
    switch (level) {
        case 'verified':
            return colors.green;
        case 'pending':
            return colors.orangeAttention;
        default:
            return colors.orangeAttention;
    }
}

export function getTextColor(level: Level) {
    switch (level) {
        case 'verified':
            return colors.black;
        case 'pending':
            return colors.orangeAttention;
        default:
            return colors.orangeAttention;
    }
}

function getIcon(level: Level) {
    switch (level) {
        case 'verified':
            return CheckmarkIcon;
        case 'pending':
        default:
            return WarningIcon;
    }
}
